module.exports = __webpack_public_path__ + "img/pttavm.935a5604.png";